import * as React                from 'react';
import { useHistory }            from 'react-router-dom';
import DV                        from 'ts-data-validator';
import { SessionStorageService } from 'ts-storage-service';

import catalogConstants    from './catalog.constants';
import CatalogContext      from './catalog.context';
import catalogReducer      from './catalog.reducer';
import catalogInitialState from './catalog.state';

import useRequest from '../../common/services/request';

const CatalogProvider = function(props) {
  const history = useHistory();

  const {
          children,
          value,
        } = props;

  const {
          catalog,
          filter,
          element: initialElement,
        } = value;

  const ss = new SessionStorageService();

  const request = useRequest();

  let offers  = {};
  let element = {};

  if (!DV.isUndefined(initialElement) && Object.keys(initialElement).length > 0) {
    initialElement?.offers?.map((o) => {
      offers = {
        ...offers,
        [`${o.common.offerId}`]: {
          common:                    {
            // here add keys (insertsIN, insertsOUT)
            backSideImage:      o.common.backSideImage,
            backSideImageAlt:   o.common.backSideImageAlt || '',
            cities:             o.common.cities || [],
            constructionTypeId: +o.common.constructionTypeId,
            description:        o.common.description,
            discountPrice:      o.common.discountPrice ? +o.common.discountPrice : null,
            discountPercent:    o.common.discountPercent,
            frontSideImage:     o.common.frontSideImage,
            frontSideImageAlt:  o.common.frontSideImageAlt || '',
            insertColorInside:  o.common.insertColorInside,
            insertColorOutside: o.common.insertColorOutside,
            isMarker:           o.common.isMarker,
            isExpressMarker:    o.common.isExpressMarker || false,
            isSpecMarker:       o.common.isSpecMarker || false,
            isInterior:         o.common.isInterior,
            interiorImage:      o.common.interiorImage,
            internalOpening:    o.common.internalOpening,
            installationTypeId:     +o.common.installationTypeId,
            installationTypeUrlKey: o.common.installationTypeUrlKey,
            label:                  o.common.label,
            modelId:            +o.common.modelId,
            moreInfoLink:       o.common.moreInfoLink,
            markerLabel:        o.common.markerLabel,
            moreInfo:           o.common.moreInfo,
            mark:               o.common.mark,
            meta:               o.common.meta,
            notAvailable:       o.common.notAvailable || false,
            offerGroupId:       +o.common.offerGroupId,
            offerId:            +o.common.offerId,
            price:              +o.common.price,
            rating:             o.common.rating,
            regions:            o.common.regions || [],
            seriesId:           +o.common.seriesId,
            sortPrice:          +o.common.sortPrice || +o.common.discountPrice || +o.common.price,
            singleSideView:     o.common.singleSideView,
            tags:               o.common.tags || [],
            updatedAt:          o.common.updatedAt,
            urlKey:             o.common.urlKey,
            vendorCode:         o.common.vendorCode,
          },
          sections:                  o.sections || [],
        },
      };
    });

    if (
      initialElement.hasOwnProperty('sliderImage') &&
      !DV.isNull(initialElement.sliderImage) &&
      DV.isNotEmptyObject(initialElement.sliderImage)
    ) {
      for (let offer in initialElement.sliderImage) {
        if (initialElement.sliderImage.hasOwnProperty(offer)) {
          if (DV.isNotEmptyArray(initialElement.sliderImage[offer]) && initialElement.sliderImage[offer].length > 0) {
            offers[offer].common.gallery = [...initialElement.sliderImage[offer]];
          }
        }
      }
    }

    element = {
      ...catalogInitialState.element,
      meta:                 initialElement.meta || catalogInitialState.element.meta,
      models:               {
        ...catalogInitialState.element.models,
        [`${initialElement.currentModelId}`]: {
          ...(
            catalogInitialState.element.models[initialElement.currentModelId] || {}),
          [`${initialElement.currentSeriesId}`]: { ...offers },
        },
      },
      currentModelId:       +initialElement.currentModelId || catalogInitialState.element.currentModelId,
      currentSeriesId:      +initialElement.currentSeriesId || catalogInitialState.element.currentSeriesId,
      currentOfferId:       +initialElement.currentOfferId || catalogInitialState.element.currentOfferId,
      currentOfferGroupId:  +initialElement.currentOfferGroupId || catalogInitialState.element.currentOfferGroupId,
      lowPrioritySeriesKey: initialElement.lowPrioritySeriesKey || catalogInitialState.element.lowPrioritySeriesKey,
      popularModels:        initialElement.popularModels || catalogInitialState.element.popularModels,
      allowedSeries:        {
        ...catalogInitialState.element.allowedSeries,
        [`${initialElement.currentModelId}`]: { ...initialElement.allowedSeries },
      },
      stb:                  {
        ...catalogInitialState.element.stb,
        max:    {
          draftProtection: +initialElement.maxStandard?.draftProtection ||
                             catalogInitialState.element.stb.max.draftProtection || 0,
          soundInsulation: +initialElement.maxStandard?.soundInsulation
                             || catalogInitialState.element.stb.max.soundInsulation || 0,
          security:        +initialElement.maxStandard?.security ||
                             catalogInitialState.element.stb.max.security || 0,
          coldProtection:  +initialElement.maxStandard?.coldProtection ||
                             catalogInitialState.element.stb.max.coldProtection || 0,
        },
        series: {
          ...catalogInitialState.element.stb.series,
          [`${initialElement.currentSeriesId}`]: {
            draftProtection: +initialElement.seriesStandard?.draftProtection ||
                               catalogInitialState.element.stb.max.draftProtection || 0,
            soundInsulation:
                             +initialElement.seriesStandard?.soundInsulation || catalogInitialState.element.stb.max.soundInsulation || 0,
            security:
                             +initialElement.seriesStandard?.security || catalogInitialState.element.stb.max.security || 0,
            coldProtection:
                             +initialElement.seriesStandard?.coldProtection || catalogInitialState.element.stb.max.coldProtection || 0,
          },
        },
      },
      initialStateLoaded:   Object.keys(initialElement).length > 0,
    };
  }

  const [state, dispatch] = React.useReducer(catalogReducer, {
    ...catalogInitialState,
    catalog: {
      ...catalogInitialState.catalog,
      meta:               catalog.meta || catalogInitialState.catalog.meta,
      items:              catalog.items || catalogInitialState.catalog.items,
      isInterior:         catalog.isInterior || catalogInitialState.catalog.isInterior,
      count:              +catalog.count || catalogInitialState.catalog.count,
      countModels:        +catalog.countModels ?? catalogInitialState.catalog.countModels,
      popularModels:      catalog.popularModels || catalogInitialState.catalog.popularModels,
      installationTypes:  catalog.installationTypes || catalogInitialState.catalog.installationTypes,
      priceBounds:        catalog.priceBounds || catalogInitialState.catalog.priceBounds,
      sort:               catalog.sort || catalogInitialState.catalog.sort,
      showMore:           Array.isArray(catalog.items) && !!catalog.count
                            ? catalog.items.length < catalog.count
                            : false,
      initialStateLoaded: Array.isArray(catalog.items),
    },
    filter:  {
      ...catalogInitialState.filter,
      filter:             filter.filter || catalogInitialState.filter.filter,
      selectedValues:     filter.selectedValues || catalogInitialState.filter.selectedValues,
      initialStateLoaded: !!filter.filter,
    },
    element: {
      ...catalogInitialState.element,
      ...element,
    },
  });

  const getCatalogFilterInitialState = React.useCallback(() => {
    dispatch({ type: catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_REQUEST });

    return request.get('/get-catalog-filter')
      .then((response) => dispatch({ type: catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_FAILURE, ...error }));

  }, [dispatch]);
  const getCatalogItem               = React.useCallback((url) => {
    dispatch({ type: catalogConstants.CATALOG_GET_ITEM_REQUEST });

    return request.get(`/api${url}`)
      .then((response) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_FAILURE, ...error }));

  }, [dispatch]);
  const getCatalogItems              = React.useCallback((url) => {
    dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_REQUEST });

    return request.get(`/api${url}`)
      .then((response) => {
        dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_SUCCESS, ...response });

        if (response.url) {
          history.replace(response.url);
        }
      })
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_FAILURE, ...error }));
  }, [dispatch]);
  const getOffersByInstallationType  = React.useCallback((model, type) => {
    dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_REQUEST });

    return request.get(`/get-series/${model}/${type}`)
      .then((response) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_FAILURE, ...error }));

  }, [dispatch]);
  const getOffersByModelAndSeries    = React.useCallback((model, series, offerGroup, isInterior) => {
    dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_REQUEST });

    const catalog = isInterior ? 'mezhkomnatnye-dveri' : 'vhodnye-dveri';

    return request.get(`/${catalog}/get-offers-by-series?modelId=${model}&seriesId=${series}&offerGroupId=${offerGroup}`)
      .then((response) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_GET_ITEM_BY_SERIES_FAILURE, ...error }));
  }, [dispatch]);
  const hideFilter                   = React.useCallback(() => {
    return dispatch({ type: catalogConstants.CATALOG_FILTER_HIDE });
  }, [dispatch]);
  const resetCatalog                 = React.useCallback(() => {
    ss.removeData('savedCatalogPage');

    dispatch({ type: catalogConstants.CATALOG_RESET_INITIAL_STATE });
  }, [dispatch]);
  const resetCatalogElement          = React.useCallback(() => {
    return dispatch({ type: catalogConstants.CATALOG_ELEMENT_RESET });
  }, [dispatch]);
  const resetFilter                  = React.useCallback(() => {
    ss.removeData('savedCatalogPage');

    dispatch({ type: catalogConstants.CATALOG_FILTER_RESET });
  }, [dispatch]);
  const resetSort                    = React.useCallback(() => {
    dispatch({ type: catalogConstants.CATALOG_RESET_SORT });
  }, [dispatch]);
  const setFilterParam               = React.useCallback((url, param = null, value = null) => {
    dispatch({
      type: catalogConstants.CATALOG_FILTER_SET_PARAM,
      param,
      value,
    });
    dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_REQUEST });

    return request.post(`/api${url}`, {
      currentUrl: url,
      param,
      value,
    })
      .then((response) => {
        dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_SUCCESS, ...response });

        if (response.url) {
          history.push(response.url);
        }
      })
      .catch((error) => {
        dispatch({ type: catalogConstants.CATALOG_GET_ITEMS_FAILURE, ...error });
      });
  }, [dispatch]);
  const setSort                      = React.useCallback((url, value) => {
    dispatch({
      sort: value,
      type: catalogConstants.CATALOG_SET_SORT_REQUEST,
    });

    return request.post(url, {
      param: 'sort',
      value,
    })
      .then((response) => {
        dispatch({ type: catalogConstants.CATALOG_SET_SORT_SUCCESS, ...response });

        if (response.url) {
          history.push(response.url);
        }
      })
      .catch((error) => {
        dispatch({ type: catalogConstants.CATALOG_SET_SORT_FAILURE, ...error });
      });
  }, [dispatch]);
  const showFilter                   = React.useCallback(() => {
    dispatch({ type: catalogConstants.CATALOG_FILTER_SHOW });
  }, [dispatch]);
  const showMoreItems                = React.useCallback((url, sort = null) => {
    dispatch({ type: catalogConstants.CATALOG_SHOW_MORE_REQUEST });

    const promise = sort
      ? request.post(`/api${url}`, {
        param: 'sort',
        value: sort,
      })
      : request.get(`/api${url}`);

    return promise
      .then((response) => dispatch({ type: catalogConstants.CATALOG_SHOW_MORE_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: catalogConstants.CATALOG_SHOW_MORE_FAILURE, ...error }));

  }, [dispatch]);

  const context = React.useMemo(() => {
    return {
      ...state,
      getCatalogFilterInitialState,
      getCatalogItem,
      getCatalogItems,
      getOffersByInstallationType,
      getOffersByModelAndSeries,
      hideFilter,
      resetCatalog,
      resetCatalogElement,
      resetFilter,
      resetSort,
      setFilterParam,
      setSort,
      showFilter,
      showMoreItems,
    };
  }, [
    state,
    getCatalogFilterInitialState,
    getCatalogItem,
    getCatalogItems,
    getOffersByInstallationType,
    getOffersByModelAndSeries,
    hideFilter,
    resetCatalog,
    resetCatalogElement,
    resetFilter,
    resetSort,
    setFilterParam,
    setSort,
    showFilter,
    showMoreItems,
  ]);

  return (
    <CatalogContext.Provider value={context}>
      {children}
    </CatalogContext.Provider>
  );
};

export default CatalogProvider;